export default {"src":"/_next/static/media/favicon_256x256.968974c1.ico","height":256,"width":256,"blurWidth":0,"blurHeight":0};